<template>
    <div>
        <div>
            <div class="mt-5 ql-editor" v-html="course.translation.description"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CourseOverview',
    props: {
        course: {
            type: Object,
        },
        color: {
            type: Object,
            required: true,
        },
        layout: Object,
    },
};
</script>

<style>
</style>
